export default __webpack_public_path__ + "static/madina-2b15e5e40efa9e868fbbd01d5f5944f9.jpg";